import { Component, EventEmitter, Input, Output } from '@angular/core';
import { KontoverbindungModel } from '../../shared/model/kontoverbindung.model';

@Component({
  selector: 'kvb-kontoverbindung-view',
  templateUrl: './kontoverbindung-view.component.html',
  styleUrl: './kontoverbindung-view.component.scss',
})
export class KontoverbindungViewComponent {
  @Input() kontoverbindungen: KontoverbindungModel[] = [];
  @Output() kontoverbindungSelectedForEditing = new EventEmitter<KontoverbindungModel>();

  hasMultipleAccounts = () => this.kontoverbindungen.length > 1;

  onEditClick(i: number) {
    this.kontoverbindungSelectedForEditing.next(this.kontoverbindungen[i]);
  }
}
